/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddGroupEmergencyEmailRequest
 */
export interface AddGroupEmergencyEmailRequest {
    /**
     * 
     * @type {string}
     * @memberof AddGroupEmergencyEmailRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEmergencyEmailRequest
     */
    group_id: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEmergencyEmailRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEmergencyEmailRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AddGroupEmergencyEmailRequest
     */
    language_code: string;
}

/**
 * Check if a given object implements the AddGroupEmergencyEmailRequest interface.
 */
export function instanceOfAddGroupEmergencyEmailRequest(value: object): value is AddGroupEmergencyEmailRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('group_id' in value) || value['group_id'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('language_code' in value) || value['language_code'] === undefined) return false;
    return true;
}

export function AddGroupEmergencyEmailRequestFromJSON(json: any): AddGroupEmergencyEmailRequest {
    return AddGroupEmergencyEmailRequestFromJSONTyped(json, false);
}

export function AddGroupEmergencyEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddGroupEmergencyEmailRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'group_id': json['group_id'],
        'email': json['email'],
        'name': json['name'],
        'language_code': json['language_code'],
    };
}

export function AddGroupEmergencyEmailRequestToJSON(json: any): AddGroupEmergencyEmailRequest {
    return AddGroupEmergencyEmailRequestToJSONTyped(json, false);
}

export function AddGroupEmergencyEmailRequestToJSONTyped(value?: AddGroupEmergencyEmailRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'group_id': value['group_id'],
        'email': value['email'],
        'name': value['name'],
        'language_code': value['language_code'],
    };
}

